import { AgentHarnessRoomMessage } from '../../../ai/agent-harness/agent.socket';
import { RoomKey } from '../socket.room.key';

export const AgentHarnessRooms = {
    agentHarness: (): RoomKey<AgentHarnessRoomMessage> => ({ key: 'agent-harness' }),
    agentHarnessApplication: (applicationId: string): RoomKey<AgentHarnessRoomMessage> => ({ key: `agent-harness:${applicationId}` }),
    agentHarnessEntity: (entityType: string, entityId: string): RoomKey<AgentHarnessRoomMessage> => ({ key: `agent-harness:entity:${entityType}:${entityId}` }),
};
